<template>
  <div>
    <div v-for="brand in brands" :key="brand.id">
      <brand-overview-stats :brand="brand"></brand-overview-stats>
      <hr>
    </div>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'

  const BrandOverviewStats = () => ({
    component: import('./../Components/BrandOverviewStats.vue')
  })

  export default {
    components: {
      BrandOverviewStats
    },
    mixins: [toolboxMixin],
    props: ['accountData'],
    data () {
      return {
        user: {},
        brandValidationData: [],
        brandRegistrationData: [],
        totalBrandValidations: 0,
        totalBrandRegistrations: 0,
        brands: []
      }
    },
    methods: {
      async init () {
        console.log('getting current user in overview')
        this.getCurrentUser().then(result => {
          console.log('got current user in overview')
          console.log(result)
          this.user = result
          console.log(this.user)
          this.getBrandsAndStats()
        })
      },
      getBrandsAndStats () {
        let brand = {
          data: this.accountData.activeBrand.data,
          id: this.accountData.activeBrand.id,
          validationData: [],
          totalValidations: 0,
          registrationData: [],
          totalRegistrations: 0,
          validationDataReady: false,
          registrationDataReady: false,
          isArchived: this.accountData.activeBrand.data.isArchived
        }
        this.brands.push(brand)
        // db.collection(`brands`).where('accountId', '==', this.user.accountId).orderBy('qtyCertified', 'desc').get().then(qs => {
        //   qs.forEach(doc => {
        //     let brand = {
        //       data: doc.data(),
        //       id: doc.id,
        //       validationData: [],
        //       totalValidations: 0,
        //       registrationData: [],
        //       totalRegistrations: 0,
        //       validationDataReady: false,
        //       registrationDataReady: false,
        //       isArchived: doc.data().isArchived
        //     }
        //     if (brand.isArchived !== true) this.brands.push(brand)
        //   })
        //   console.log(this.brands)
        // })
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Overview.vue